import { resolveFeatureFlags } from "@repo/schema";
import { useMemo } from "react";
import { useAuth } from "./useAuth";

/**
 * Effective feature flags for the current organization — declared defaults with
 * the org's stored overrides applied.
 *
 * Reads from the auth slice, which is populated by the session token, so this
 * costs no extra request. A super admin's save patches the slice immediately;
 * other users pick up a change on their next token refresh (which `useAuthInit`
 * triggers on page load).
 */
export const useFeatureFlags = () => {
  const { organization } = useAuth();
  return useMemo(
    () => resolveFeatureFlags(organization?.featureFlags),
    [organization?.featureFlags],
  );
};
